export const baseUrl = "https://ibrohimbek.links";

export const seoData = {
	title: "Ibrohimbek Alisherov | Personal Links",
	description:
		"Official link tree of Ibrohimbek Alisherov — web developer. Portfolio, social media, projects, and useful links in one place.",
	keywords: [
		"Ibrohimbek",
		"Ibrohimbek Alisherov",
		"ibrohimbek links",
		"personal link tree",
		"web developer",
		"frontend developer",
		"react developer",
		"next.js developer",
		"portfolio links",
		"developer links",
		"Uzbek developer",
	].join(", "),
	image: `${baseUrl}/og-image.jpg`,
};
